/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockTenderReviewCtrl
 */
angular.module('mercury.modules.stock.tender')
.controller('StockTenderReviewCtrl', ["$filter", "$location", "$state", "$stateParams", "$scope", "StockTenders", "title", function($filter, $location, $state, $stateParams, $scope, StockTenders, title) {
  title.set('Tender Review');

  $scope.returnParams = JSON.stringify({name: $state.current.name, params: $stateParams});

  $scope.reviewStart = $stateParams.start;
  $scope.reviewEnd = $stateParams.end;
  $scope.includeCredits = $stateParams.credits;

  $scope.loading = StockTenders.review($stateParams.id, $stateParams.start, $stateParams.end, $stateParams.credits).$promise;
  $scope.loading.then(function(tender) {
    $scope.tender = tender;

    $scope.supplierVariance = 0;

    var uniqueInvoicesWithVariance = {};

    angular.forEach($scope.tender.lines, function(tenderLine) {
      var totalOrderQuantity = 0;
      var totalOrderUnitPrice = 0;
      var totalOrderVariance = 0;
      var totalInvoicesWithVariance = 0;

      angular.forEach(tenderLine.orders, function(orderLine) {
        orderLine.totalVariance = orderLine.quantity * (tenderLine.unitCost - orderLine.unitCost);

        totalOrderQuantity += orderLine.quantity;
        totalOrderUnitPrice += orderLine.unitCost;
        totalOrderVariance += orderLine.totalVariance;

        if (orderLine.totalVariance !== 0) {
          uniqueInvoicesWithVariance[orderLine.purchaseOrderId] = true;

          totalInvoicesWithVariance++;
        }
      });

      tenderLine.totals = {
        quantity: totalOrderQuantity,
        unitcost: (totalOrderUnitPrice / tenderLine.orders.length) || 0,
        unitVariance: tenderLine.unitCost - (totalOrderUnitPrice / tenderLine.orders.length) || 0,
        variance: totalOrderVariance,
        varianceCount: totalInvoicesWithVariance
      };

      $scope.supplierVariance += totalOrderVariance;
    });

    var uniqueVarianceCount = 0;
    angular.forEach(uniqueInvoicesWithVariance, function() {
      uniqueVarianceCount++;
    });
    $scope.uniqueVarianceCount = uniqueVarianceCount;
  });

  $scope.paramsChanged = function() {
    return moment($stateParams.start).isSame($scope.reviewStart) === false ||
      moment($stateParams.end).isSame($scope.reviewEnd) === false ||
      $stateParams.credits != $scope.includeCredits;
  };
}]);
